import styled, { css } from 'styled-components'
import { CLICKABLE_COLOR } from '@CSSVars/colors'

import AppLink from 'Components/AppLink'

const iconCont = css`
  position: relative;
  margin-right: 12px;
`

export const _IconContAppLink = styled(AppLink)`
  ${iconCont};
  height: ${({ isPrint }) => (isPrint ? '15px' : '25px')};
  line-height: 20px;
  ${({ titlecomp }) => (
    titlecomp ?
      `
        display: flex;
        align-items: center;
        svg {
          fill: HYPER_LINK_COLOR;
          margin-left: 2px;
          margin-top: 2px;
        }
      ` : ''
  )}
  svg {
    fill: ${CLICKABLE_COLOR};
  }
`
